import {useState, useEffect} from "react";
import {ReactComponent as Logo} from "../images/icxeed-logo.svg";
import {ReactComponent as EditIcon} from "../images/edit-icon.svg";
import {ReactComponent as SearchIcon} from "../images/search-icon.svg";
import {ReactComponent as ToggleIcon} from "../images/toggle-icon.svg";
import {ReactComponent as MobileToggleIcon} from "../images/mobile-menu-icon.svg";
import Avatar from "./Avatar";

type SideBarProps = {
  isExpanded: boolean;
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
};
const SiderBar = ({isExpanded, setIsExpanded}: SideBarProps) => {
  const [iconHover, setIconHover] = useState(false);
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setViewportWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleMouseEnter = () => setIconHover(true);
  const handleMouseLeave = () => setIconHover(false);

  const handleExpand = () => setIsExpanded(true);
  const handleCollapse = () => setIsExpanded(false);

  const getToggleClass = () =>
    `toggle-element ${isExpanded ? "toggle-element-active" : ""}`;

  return (
    <div className={`iris-sidebar ${isExpanded ? "expanded" : "collapsed"}`}>
      <div className="iris-sidebar-content-blk">
        <div className="iris-sidebar-logo iris-flex-box-blk">
          {viewportWidth < 900 ? (
            isExpanded ? (
              <Logo
                onClick={handleExpand}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                style={{height: "30px"}}
              />
            ) : (
              <MobileToggleIcon
                onClick={isExpanded ? handleCollapse : handleExpand}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                style={{height: "30px"}}
              />
            )
          ) : iconHover && !isExpanded ? (
            <ToggleIcon
              onClick={handleExpand}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              style={{height: "30px"}}
            />
          ) : (
            <Logo
              onClick={handleExpand}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              style={{height: "30px"}}
            />
          )}

          <ToggleIcon
            style={{width: "15px"}}
            className={`toggle-icon-blk ${getToggleClass()}`}
            onClick={handleCollapse}
          />
        </div>

        {!(viewportWidth < 900 && !isExpanded) && (
          <div
            className={`iris-flex-box-blk ${!(
              viewportWidth < 900 && !isExpanded
            )} && 'toggle-element-active'`}>
            <EditIcon />
            <p className={getToggleClass()}>New Chat</p>
          </div>
        )}

        {!(viewportWidth < 900 && !isExpanded) && (
          <div
            className={`iris-flex-box-blk ${!(
              viewportWidth < 900 && !isExpanded
            )} && 'toggle-element-active'`}>
            <SearchIcon />
            <p className={getToggleClass()}>Search</p>
          </div>
        )}

        <div className={`chat-history-blk ${isExpanded ? "active" : ""}`}>
          <h1>Chats</h1>
          <ul>
            <li>Creating a contact flow</li>
            <li>Renaming a queue</li>
            <li>Claiming number issue</li>
          </ul>
        </div>

        <Avatar isExpanded={isExpanded} />
      </div>
    </div>
  );
};

export default SiderBar;
